<div class="row">
  <div class="col-12">
    <div class="card card-body">
      <div class="">
        <h4 class="card-title mb-0">
          <span class="lstick"></span>Users Advance Booking List
        </h4>
        <br />
        <div class="row content">
          <div class="col content-date">
            <div class="form-group row">
              <label for="startdate" class="col-sm-4 col-form-label"
                >Start date</label
              >
              <input
                type="date"
                class="form-control"
                onkeydown="return false"
                name="startdate"
                [(ngModel)]="startDate"
                id="startdate"
                ngModel
                #startdate="ngModel"
                required
              />
            </div>
          </div>
          &nbsp;
          <div class="col content-date">
            <div class="form-group row">
              <label for="enddate" class="col-sm-4 col-form-label">
                End date</label
              >
              <input
                type="date"
                class="form-control"
                onkeydown="return false"
                min="{{ startDate }}"
                name="enddate"
                [(ngModel)]="endDate"
                id="enddate"
                ngModel
                #enddate="ngModel"
                required
              />
            </div>
          </div>
          <div class="col-md-1 bttn">
            <button
              class="btn btn-primary ml-auto"
              placement="top"
              (click)="filterbydate()"
              ngbTooltip="Search between days"
            >
              Search
            </button>
          </div>

          <!-- <div class="col-md-1 text-left bttn">
                        <a href="javascript: void(0);" class="btn btn-primary pull-right" placement="top"
                            (click)="getPdf()" ngbTooltip="pdf">
                            <i class="fas fa-file-alt"></i> PDF
                        </a>
                    </div> -->

          <div class="col-md-1 text-left bttn">
            <a
              href="javascript: void(0);"
              class="btn btn-primary pull-right"
              placement="top"
              (click)="getCsv()"
              ngbTooltip="Export as CSV"
            >
              <i class="fas fa-file-alt"></i> Export
            </a>
          </div>
        </div>
        <div class="form-group row"></div>
        <div class="d-flex mt-3"></div>
      </div>
      <div class="table-responsive">
        <table class="table table-striped border mt-4">
          <thead>
            <tr>
              <th scope="col">Image</th>
              <th scope="col">Title</th>
              <!-- <th scope="col">User</th> -->
              <th scope="col">Email</th>
              <th scope="col">User Mobile</th>
              <th scope="col">Asset Type</th>
              <th scope="col">Package Type</th>
              <th scope="col">Fees</th>
              <th scope="col">Deposite</th>
              <th scope="col">Extra Charge Fee</th>
              <th scope="col">Time</th>
              <!-- <th scope="col">Brand Name</th>
                            <th scope="col">Total Asset Allowed</th>
                            <th scope="col">Duration</th>
                            <th scope="col">Timing</th>
                            <th scope="col">Vat(%)</th> -->
              <th scope="col">Start Date</th>
              <th scope="col">End Date</th>
              <th scope="col" style="text-align: center">Status</th>
              <th scope="col">Action</th>
              <!-- <th scope="col">Receipt</th> -->
            </tr>
          </thead>
          <tbody *ngFor="let d of data">
            <tr>
              <td>
                <ng-container *ngIf="d?.package_id?.poster_image; else noImage">
                  <img [src]="d.package_id.poster_image" width="40" />
                </ng-container>
                <ng-template #noImage>-</ng-template>
              </td>

              <td>
                {{ d?.package_id?.title ? d?.package_id?.title : "-" }}
              </td>
              <!-- <td style="width: 80px">{{ d?.user_id?.username?d?.user_id?.username:'-' }}</td> -->
              <td>
                {{ d?.user_id?.email ? d?.user_id?.email : "-" }}
              </td>

              <td>
                {{ d?.user_id?.mobile ? d?.user_id?.mobile : "-" }}
              </td>
              <td>
                {{ d?.package_id?.type ? d?.package_id?.type : "-" }}
              </td>
              <td>
                {{
                  d?.package_type == "activities"
                    ? "Activities"
                    : d?.package_type == "self_serve"
                    ? "Self Serve"
                    : d?.package_type == "rentx"
                    ? "RentX"
                    : "-"
                }}
              </td>
              <td>
                {{ d?.package_id?.price ? d?.package_id?.price : "0" }}
                {{ currency }}
              </td>
              <td>
                {{
                  d?.package_id?.security_deposit
                    ? d?.package_id?.security_deposit
                    : "0"
                }}
                {{ currency }}
              </td>
              <td>
                {{ d?.extra_ride_fee }}
              </td>
              <td>
                {{ d?.start_date | date : "hh:mm a" }} -
                {{ d?.end_date | date : "hh:mm a" }}
              </td>
              <!-- <td>
                                {{ d?.brand_name }}
                            </td>
                            <td>
                                {{ d?.total_asset_used }}
                            </td>
                            <td>
                                {{ d?.package_id?.duration?d?.package_id?.duration:"-" }}
                            </td>
                            <td>
                                {{ d?.package_id?.timing?d?.package_id?.timing:"-" }}
                            </td>
                            <td>
                                {{ d?.package_id?.vat?d?.package_id?.vat:"-" }}
                            </td> -->
              <td>
                {{ d?.start_date | date }}
              </td>
              <td>
                {{ d?.end_date | date }}
              </td>
              <td style="text-align: center">
                {{
                  d?.status == "upcoming"
                    ? "Upcoming"
                    : d?.status == "cancel_request"
                    ? "Cancel Request"
                    : d?.status == "refund_request"
                    ? "Request Refund"
                    : d?.status == "active"
                    ? "Active"
                    : d?.status == "returned"
                    ? "Returned"
                    : d?.status == "completed"
                    ? "Completed"
                    : d?.status == "cancelled"
                    ? "Cancelled"
                    : d?.status == "expired"
                    ? "Expired"
                    : d?.status == "refunded"
                    ? "Refunded"
                    : "-"
                }}
              </td>
              <td>
                <a
                  href="javascript: void(0);"
                  class="link mr-2"
                  placement="top"
                  (click)="openModal(AddModal, d, 'Add Employee')"
                  ngbTooltip="Add Employee"
                  *ngIf="!isEmployee"
                >
                  <i class="fa fa-user-plus"></i>
                </a>
              </td>
            </tr>

            <tr *ngIf="data.length == 0">
              <td colspan="13">No data found</td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center mt-5">
          <ngb-pagination
            [(page)]="page"
            [pageSize]="pageSize"
            [collectionSize]="totalcount"
            [maxSize]="7"
            [rotate]="true"
            [ellipses]="false"
            [boundaryLinks]="true"
            (pageChange)="loadPage($event)"
          ></ngb-pagination>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Export Modal Template -->
<ng-template #exportModalContent let-close="close">
  <div class="modal-header">
    <h5 class="modal-title">Export Data</h5>
    <button type="button" class="close" (click)="closeBtnClick()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="exportForm">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="startDate">Start date</label>
            <input
              type="date"
              class="form-control"
              id="startDate"
              formControlName="startDate"
              [max]="today"
              onkeydown="return false"
            />
            <div
              *ngIf="
                exportForm.get('startDate').invalid &&
                exportForm.get('startDate').touched
              "
              class="text-danger small"
            >
              Start date is required
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="endDate">End date</label>
            <input
              type="date"
              class="form-control"
              id="endDate"
              formControlName="endDate"
              [min]="exportForm.get('startDate').value"
              [max]="today"
              onkeydown="return false"
            />
            <div
              *ngIf="
                exportForm.get('endDate').invalid &&
                exportForm.get('endDate').touched
              "
              class="text-danger small"
            >
              <span *ngIf="exportForm.get('endDate').errors?.required"
                >End date is required</span
              >
              <span *ngIf="exportForm.get('endDate').errors?.invalidDate"
                >End date must be after start date</span
              >
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="closeBtnClick()">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="exportWithSelectedDates()"
    >
      <i class="fas fa-file-alt"></i> Export CSV
    </button>
  </div>
</ng-template>
<ng-template #AddModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ modeltitle }}</h5>
    <button
      type="button"
      class="close"
      (click)="closeBtnClick()"
      aria-label="Close"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <form (ngSubmit)="onAddEmployeeSubmit(employeeForm)" #employeeForm="ngForm">
      <div class="form-group row">
        <label for="selectedEmployee" class="col-sm-4 col-form-label">
          Select Employee *
        </label>
        <div class="col-sm-8">
          <select
            class="form-control"
            name="selectedEmployee"
            [(ngModel)]="selectedEmployeeId"
            id="selectedEmployee"
            [disabled]="preSelectedEmployee"
            required
          >
            <option value="" disabled>Choose an employee...</option>
            <option
              *ngIf="preSelectedEmployee"
              [value]="preSelectedEmployee._id"
              selected
            >
              {{ preSelectedEmployee.email }}
            </option>
            <option
              *ngFor="let employee of employeeList"
              [value]="employee._id"
              [hidden]="
                preSelectedEmployee && employee._id === preSelectedEmployee._id
              "
            >
              {{ employee.email }}
            </option>
          </select>
          <small class="form-text text-muted">
            {{
              preSelectedEmployee
                ? "An employee is already assigned to this booking"
                : "Select an employee from the list"
            }}
          </small>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeAddEmployeeBtnClick()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!employeeForm.valid || !selectedEmployeeId"
        >
          {{ preSelectedEmployee ? "Update Employee" : "Add Employee" }}
        </button>
      </div>
    </form>
  </div>
</ng-template>
